import React from "react";
import "../style/CarOverview.css";
import { useNavigate } from 'react-router-dom';

function CarOverview(carro) {
  let backgroundurl = carro.carro.imagenes[0];
  backgroundurl = backgroundurl.replace("http://", "https://")
  const navigate = useNavigate();

  const clickoverview = () => {
    navigate("/info/" + carro.carro._id)
  }

  function formatNumberWithCommas(number) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }


  const isOnSale = Boolean(carro.carro.offerta) && Number(carro.carro.precioOferta) > 0;

  return (
    <>
      <div onClick={clickoverview} style={{ "--background-image": `url(${backgroundurl})` }}
        className="car-updated">
          <div className="new-car-container">
            <span className="card-tag card-tag-nuevo">Nuevo</span>
            {carro.carro.thirdPartySeller && (
              <span className="third-party-badge">Vendedor Externo</span>
            )}
            {carro.carro.enSubasta && (
              <span className="third-party-badge auction-card-badge">En subasta</span>
            )}
          </div>
          {isOnSale && (
            <span className="card-offer-badge">Oferta</span>
          )}
            <div className="info-part-h">
              {isOnSale && (
                <span className="price-original" translate="no">
                  L.{formatNumberWithCommas(carro.carro.precio)}
                </span>
              )}
              <h1 className="price-home" translate="no">L.{formatNumberWithCommas(isOnSale ? carro.carro.precioOferta : carro.carro.precio)}</h1>
              <h2 className="car-model-h">
                {carro.carro.marca} {carro.carro.modelo} {carro.carro.anio}
              </h2>
              {carro.carro.lote !== '0' && (<p className="lote" id="car-lote-h">Lote: {carro.carro.lote}</p>)}
          </div>
      </div>
    </>
  );
}

export default CarOverview;
